var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-tools-tabs"},[_c('tabs',{attrs:{"items":_vm.tabs,"active-tab":_vm.activeTab},on:{"click":_vm.activateTab}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }